module.exports = __webpack_public_path__ + "static/img/3业务布局-智能制造.54b79382.png";